import React from 'react';
import PropTypes from 'prop-types';
import CegadatContent from './CegadatContent';
import { useLocation } from 'react-router';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './CegadatTooltips';

const cardStyle = {
  padding: 20
};

const CegadatBase = (props) => {
  let lek = null;
  const location = useLocation();
  if (location.state) {
    lek = location.state.lek;
  }
  return (
    <div>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            {'Cégadatok'}
            <CustomTooltip text={getTooltip('cegadat')} id="cegadatTT" />
          </div>
          <div className="row" style={cardStyle}>
            <div className="col-md-12">
              <CegadatContent {...props} globals={props.globals} lek={lek} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CegadatBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object,
  location: PropTypes.object,
  state: PropTypes.object,
};

export default CegadatBase;
